export default __webpack_public_path__ + "static/media/dprange.6941e608.svg";